var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "dialog-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-content" }, [
        _c("div", { staticClass: "dialog-header" }, [
          _c("h2", { staticClass: "dialog-title" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _c(
            "button",
            { staticClass: "close-icon-btn", on: { click: _vm.close } },
            [_c("IconClose")],
            1
          ),
        ]),
        _c("div", { staticClass: "dialog-body" }, [
          _vm._v(_vm._s(_vm.content)),
        ]),
        _c("footer", [
          _c("button", { staticClass: "close-btn", on: { click: _vm.close } }, [
            _vm._v(_vm._s(_vm.$t("common.close"))),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }